// Do not use this on production.
// All templates should be precompiled.

import {fetch_status, fetch_text, fetch_error, fetch_error_message} from './fetch.js';

var Template = {
	compiled: {},
	pending: {}, // Store ongoing promises for templates

	load: function (template_url) {
		// If template is already compiled, return a resolved promise
		if (this.compiled[template_url]) {
			return Promise.resolve(this.compiled[template_url]);
		}

		// If a fetch is already in progress for this template, return the same promise
		if (this.pending[template_url]) {
			return this.pending[template_url];
		}

		// Otherwise, initiate the fetch and store the promise
		this.pending[template_url] = fetch(template_url)
			.then(fetch_status)
			.then(fetch_text)
			.then(text => {
				const compiledTemplate = this.compile(text, template_url);
				delete this.pending[template_url]; // Remove pending status once loaded
				return compiledTemplate;
			})
			.catch(error => {
				delete this.pending[template_url]; // Ensure pending is cleared on failure
				return error.text().then(fetch_error_message);
			});

		return this.pending[template_url];
	},

	compile: function(template, template_name) {
		if (!this.compiled[template_name]) {
			this.compiled[template_name] = Handlebars.compile(template);
		}
		return this.compiled[template_name];
	},

	render: function(template, context) {
		return template(context);
	}
};

export default Template;